import { } from './styles';
import { IPresenterProps } from './types';
import { Link } from "react-router-dom";

const HomePresenter = (props: IPresenterProps) => {

    return (
        <div>
            <h1>This is the ABOUT page</h1>
            <Link to="about">Click to view our about page</Link>
        </div>
    )
};

export default HomePresenter;
